
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"12.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Tool","transform":"translate(-684.001 -496.926)"}},[_c('g',{attrs:{"id":"Group_23389","data-name":"Group 23389","transform":"translate(684 496.926)","fill":"#777a8d"}},[_c('path',{attrs:{"id":"Path_20078","data-name":"Path 20078","d":"M273.928 459.584h8.75a3.129 3.129 0 013.125 3.125v6.25a3.129 3.129 0 01-3.125 3.125h-8.75a3.129 3.129 0 01-3.125-3.125v-6.25a3.13 3.13 0 013.125-3.125zm10.625 9.375v-6.25a1.875 1.875 0 00-1.875-1.875H278.3v10h4.375a1.874 1.874 0 001.878-1.875zm-12.5 0a1.875 1.875 0 001.875 1.875h3.125v-10h-3.125a1.876 1.876 0 00-1.875 1.875z","transform":"translate(-270.803 -459.584)"}}),_c('g',{attrs:{"id":"Group_23512","data-name":"Group 23512","transform":"translate(2 2.713)"}},[_c('path',{attrs:{"id":"Path_20080","data-name":"Path 20080","d":"M282.285 464.872h-1.357a.625.625 0 100 1.25h1.357a.625.625 0 100-1.25z","transform":"translate(-280.303 -462.297)"}}),_c('path',{attrs:{"id":"Path_20081","data-name":"Path 20081","d":"M283.178 462.3h-2.25a.625.625 0 000 1.25h2.25a.625.625 0 100-1.25z","transform":"translate(-280.302 -462.297)"}}),_c('path',{attrs:{"id":"Path_20082","data-name":"Path 20082","d":"M282.285 464.872h-1.357a.625.625 0 100 1.25h1.357a.625.625 0 100-1.25z","transform":"translate(-280.303 -459.722)"}})])])])])
          )
        }
      }
    